import { useTranslation } from 'react-i18next';
import './PublicPage.css';

export default function AboutPage() {
    const { t } = useTranslation();

    return (
        <div className="public-page about-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>{t('about.hero_title')}<span className="accent">AI</span></h1>
                    <p>{t('about.hero_subtitle')}</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>{t('about.mission_title')}</h3>
                            <p>{t('about.mission_text')}</p>
                        </div>
                        <div className="modern-card">
                            <h3>{t('about.tech_title')}</h3>
                            <p>{t('about.tech_text')}</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>{t('about.why_title')}</h2>
                    <ul className="benefits-list">
                        <li><strong>{t('about.personalized')}</strong>: {t('about.personalized_desc')}</li>
                        <li><strong>{t('about.comprehensive')}</strong>: {t('about.comprehensive_desc')}</li>
                        <li><strong>{t('about.integrated')}</strong>: {t('about.integrated_desc')}</li>
                        <li><strong>{t('about.time_saving')}</strong>: {t('about.time_saving_desc')}</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}
